module.exports = __webpack_public_path__ + "img/agriasbutterfly.77ccdd7a.png";